module.exports = __webpack_public_path__ + "static/media/19ESCAP45.cbbd41d8.jpg";